/**
 * OWA Cart Share — Custom element for sharing cart as a Shopify permalink
 * Uses native Web Share API on mobile, clipboard fallback on desktop.
 */
if (!customElements.get('owa-cart-share')) {
  class OwaCartShare extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.shareTitle = this.dataset.shareTitle || '';
      this.shareText = this.dataset.shareText || '';
      this.shareToast = this.dataset.shareToast || '';
      this.sharePrompt = this.dataset.sharePrompt || '';
    }

    connectedCallback() {
      this.button.addEventListener('click', () => this.shareCart());
    }

    buildCartPermalink() {
      const inputs = document.querySelectorAll('input.quantity__input[data-quantity-variant-id]');
      if (inputs.length === 0) return null;

      const pairs = [];
      inputs.forEach(input => {
        const variantId = input.dataset.quantityVariantId;
        const qty = input.value;
        if (variantId && parseInt(qty, 10) > 0) {
          pairs.push(`${variantId}:${qty}`);
        }
      });

      if (pairs.length === 0) return null;
      return `${window.location.origin}/cart/${pairs.join(',')}`;
    }

    async shareCart() {
      const url = this.buildCartPermalink();
      if (!url) return;

      if (navigator.share) {
        try {
          await navigator.share({
            title: this.shareTitle,
            text: this.shareText,
            url: url,
          });
          return;
        } catch (e) {
          /* User cancelled or share failed — fall through to clipboard */
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        this.showToast(this.shareToast);
      } catch (e) {
        prompt(this.sharePrompt, url);
      }
    }

    showToast(message) {
      let toast = document.querySelector('.owa-cart__share-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'owa-cart__share-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      requestAnimationFrame(() => {
        toast.classList.add('active');
        setTimeout(() => toast.classList.remove('active'), 3000);
      });
    }
  }

  customElements.define('owa-cart-share', OwaCartShare);
}
